// Build a CSS transform string from a stored image adjustment
// ({ scale, position: "x% y%" }) — same format the logo adjuster produces.
// Returns 'none' when there is nothing to apply.
export default function buildImgTransform(adjust) {
  if (!adjust) return 'none';
  const z = Number(adjust.scale) || 1;
  const m = String(adjust.position || '').match(/(-?\d+(?:\.\d+)?)%\s+(-?\d+(?:\.\d+)?)%/);
  const tx = m ? `${m[1]}%` : '0%';
  const ty = m ? `${m[2]}%` : '0%';
  if (tx === '0%' && ty === '0%' && z === 1) return 'none';
  return `translate(${tx}, ${ty}) scale(${z})`;
}
